import { Tag, TagLabel, TagProps } from '@chakra-ui/react';
import React, { FC } from 'react';

type Props = TagProps;

export const CmTag: FC<Props> = ({
  size,
  colorScheme,
  children,
  padding = '4px 8px',
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <Tag
      // @ts-ignore TS2590
      {...{ size, colorScheme, padding }}
      borderRadius="full"
      variant="solid"
      fontWeight={'bold'}
      {...rest}
      minH="0"
    >
      <TagLabel>{children}</TagLabel>
    </Tag>
  );
};
